import React from 'react';

interface States {
}

interface Props {
    text: String;
}

class Heading extends React.Component<Props, States> {

    state: States

    constructor(props: Props) {
        super(props)
        this.state = {}

    }

    render() {
        return (
            <div>
                <h2
                    className="heading">
                    {this.props.text}
                </h2>
            </div>
        )
    }
}

export default Heading;
